import { Component, OnInit, Inject, Input, Output, EventEmitter } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { FeaturesComponent } from '../features/features.component';

@Component({
  selector: 'app-roles',
  templateUrl: './roles.component.html',
  styleUrls: ['./roles.component.scss']
})
export class RolesComponent implements OnInit {
  roles: any = [];
  selectAllCheck: boolean = false;
  constructor(private dialog: MatDialogRef<FeaturesComponent>) { }
  @Input() parentData: any = {};
  @Output() rolesToSend = new EventEmitter<{}>();
  ngOnInit() {
    this.rolesInit();
  }

  rolesInit() {
    if (this.parentData.selectedRoles.length) {
      this.parentData.selectedRoles.forEach(element => {
        const temp: any = {
          functionalities: []
        };
        temp.name = element.name;
        temp._id = element._id;
        temp.showHide = true;
        temp.checked = element.checked || false;
        temp.hidden = element.hidden ? element.hidden : false;
        if (element.auth_children && element.auth_children.length) {
          element.auth_children.forEach(item => {
            const temp1: any = {};
            temp1.name = item.name;
            temp1._id = item._id;
            temp1.checked = item.checked || false;
            temp.functionalities.push(temp1);
          });
        } else if (element.functionalities && element.functionalities.length) {
          element.functionalities.forEach(item => {
            const temp1: any = {};
            temp1.name = item.name;
            temp1._id = item._id;
            temp1.checked = item.checked || false;
            temp.functionalities.push(temp1);
          });
        }
        this.roles.push(temp);
      });
    }
    this.preSelect();
  }
  preSelect() {
    this.roles.forEach(element => {
      this.parentData.preSelectedRoles.forEach(ele => {
        if (ele._id === element._id) {
          element.checked = true;
          element.functionalities.forEach(f => {
            f.checked = true;
          });
        }
      });
      element.functionalities.forEach(fun => {
        this.parentData.preSelectedFunctions.forEach(ele => {
          if (ele._id === fun._id) {
            fun.checked = true;
          }
        });
      });
    });
  }
  roleSelect(feature) {
    feature.functionalities.forEach(element => {
      element.checked = feature.checked;
    });
    if (feature.checked) {
      if (feature.name.includes('Administrator')) {
        const role = feature.name.replace('Administrator', 'Executive');
        this.selectExecutive(role);
      }
    }
  }
  selectExecutive(role) {
    this.roles.forEach(ele => {
      if (role === ele.name) {
        ele.checked = true;
        ele.functionalities.forEach(fun => {
          fun.checked = true;
        });
      }
    });
  }
  functionSelect(feature) {
    let check = true;
    feature.functionalities.forEach(element => {
      check = check && element.checked;
    });
    feature.checked = check;
  }

  submit() {
    // this.dialog.close(this.roles);
    this.rolesToSend.emit(this.roles);
  }

  closeDialog() {
    this.dialog.close();
  }
  selectAll(){
    this.selectAllCheck = !this.selectAllCheck;
    this.roles.forEach(element => {
      element.checked = this.selectAllCheck;
      element.functionalities.forEach(element => {
        element.checked = this.selectAllCheck;
      });
    });
  }
}
